import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function LeftArrowIcon(props) {
    return /*#__PURE__*/ _jsxs("svg", {
        width: "36",
        height: "36",
        viewBox: "0 0 36 36",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ _jsx("circle", {
                cx: "18",
                cy: "18",
                r: "16",
                stroke: "white",
                "stroke-width": "2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M20 12L14 18L20 24",
                stroke: "white",
                "stroke-width": "2"
            })
        ]
    });
}
